// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetCallWeComConfigsQuery,
    BaseResponseCallWeComConfigFoundResponse,
    PostCallWeComConfigsBody,
} from '../types';

/**
 * findOne
 *
 * @export
 * @tags call-we-com-config-controller
 * @link [GET] /callWeComConfigs
 */
export function getCallWeComConfigs(): Promise<BaseResponseCallWeComConfigFoundResponse>;
export function getCallWeComConfigs(
    options: ApiOptions<never, GetCallWeComConfigsQuery>
): Promise<BaseResponseCallWeComConfigFoundResponse>;
export function getCallWeComConfigs(
    options?: ApiOptions<never, GetCallWeComConfigsQuery>
): Promise<BaseResponseCallWeComConfigFoundResponse> {
    return request<never, never, GetCallWeComConfigsQuery>('/callWeComConfigs', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCallWeComConfigs',
    });
}

/**
 * save
 *
 * @export
 * @tags call-we-com-config-controller
 * @link [POST] /callWeComConfigs
 */
export function postCallWeComConfigs(
    data: PostCallWeComConfigsBody
): Promise<BaseResponseCallWeComConfigFoundResponse>;
export function postCallWeComConfigs(
    data: PostCallWeComConfigsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseCallWeComConfigFoundResponse>;
export function postCallWeComConfigs(
    data: PostCallWeComConfigsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseCallWeComConfigFoundResponse> {
    return request<PostCallWeComConfigsBody, never, never>('/callWeComConfigs', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postCallWeComConfigs',
    });
}

export const meta = [
    { tags: ['call-we-com-config-controller'], path: '/callWeComConfigs', method: 'get' },
    { tags: ['call-we-com-config-controller'], path: '/callWeComConfigs', method: 'post' },
];
